import { IStatusState } from "./status/types";
import { statusReducer } from "./status/reducers";
import { IAuthState } from "./auth/types";
import { authReducer } from "./auth/reducers";
import { contextReducer } from "./context/reducers";
import { IContextState } from "./context/types";

// the top-level state object
export interface IApplicationState {
  status: IStatusState;
  auth: IAuthState;
  context: IContextState;
}

// whenever an action is dispatched, Redux will update each top-level application state property using
// the reducer with the matching name. It's important that the names match exactly, and that the reducer
// acts on the corresponding ApplicationState property type.
export const reducers = {
  status: statusReducer,
  auth: authReducer,
  context: contextReducer,
};

// this type can be used as a hint on action creators so that its 'dispatch' and 'getState' params are
// correctly typed to match your store.
export interface IAppThunkAction<TAction> {
  (dispatch: (action: TAction) => void, getState: () => IApplicationState): void;
}
